import { el } from "@dhx/ts-common/dom";
import { locale } from "@dhx/ts-diagram";
import { DiagramEditorEvents } from "../types";

function resetAction(_e, node) {
	node.data.editor?.history?.undo(true);
	node.data.editor.events.fire(DiagramEditorEvents.resetButton);
}

function applyAction(_e, node) {
	node.data.editor?.history?.reset();
	node.data.editor.events.fire(DiagramEditorEvents.applyButton);
}

function undoAction(_e, node) {
	node.data.editor?.history?.undo();
	node.data.editor.events.fire(DiagramEditorEvents.undoButton);
}

function redoAction(_e, node) {
	node.data.editor?.history?.redo();
	node.data.editor.events.fire(DiagramEditorEvents.redoButton);
}

function zoomAction(_e, node) {
	const editor = node.data.editor;
	if (node.data.dir === "in") {
		editor.events.fire(DiagramEditorEvents.zoomIn);
	} else {
		editor.events.fire(DiagramEditorEvents.zoomOut);
	}
}

function visibilityAction(_e, node) {
	const editor = node.data.editor;
	editor.events.fire(DiagramEditorEvents.visibility);
}

function exportData(_e, node) {
	const editor = node.data.editor;
	editor.events.fire(DiagramEditorEvents.exportData);
}

function importData(editor, data) {
	editor.events.fire(DiagramEditorEvents.importData, [data]);
}

function autoLayout(_e, node) {
	const editor = node.data.editor;
	editor.events.fire(DiagramEditorEvents.autoLayout);
}

export function topbar(editor) {
	const { controls } = editor.config;
	const state = editor?.history;

	const buttonReset = el(
		"button",
		{
			class:
				"dhx_button dhx_button--size_small dhx_button--color_primary dhx_button--view_link dhx_button__topbar",
			dhx_id: "resetAll",
			_data: { editor },
			onclick: [resetAction],
			type: "button",
		},
		[el("span.dhx_button__text", locale.resetChanges)]
	);

	const buttonApply = el(
		"button",
		{
			class:
				"dhx_button dhx_button--size_small dhx_button--color_primary dhx_button--view_flat dhx_button__topbar",
			dhx_id: "applyAll",
			_data: { editor },
			onclick: [applyAction],
			type: "button",
		},
		[el("span.dhx_button__text", locale.applyAll)]
	);

	const buttonExport = el(
		"button",
		{
			class:
				"dhx_button dhx_button--size_small dhx_button--color_primary dhx_button--view_link dhx_button__topbar",
			dhx_id: "exportData",
			_data: { editor },
			onclick: [exportData],
			type: "button",
		},
		[el("span.dhx_button__text", locale.exportData)]
	);

	function readFile(event) {
		const input = event.target;
		const reader = new FileReader();
		reader.onload = function() {
			importData(editor, reader.result);
		};
		reader.readAsText(input.files[0]);
	}

	const buttonImport = el(
		"label",
		{
			class:
				"dhx_button dhx_button--size_small dhx_button--color_primary dhx_button--view_link dhx_button__topbar",
			dhx_id: "importData",
			_data: { editor },
			for: "file-upload",
		},
		[
			el("span.dhx_button__text", locale.importData),
			el("input", {
				id: "file-upload",
				type: "file",
				style: { display: "none" },
				accept: "application/JSON",
				onchange: [readFile],
			}),
		]
	);

	const buttonAutoLayout = el(
		"button",
		{
			class:
				"dhx_button dhx_button--size_small dhx_button--color_primary dhx_button--view_flat dhx_button__topbar",
			dhx_id: "autoLayout",
			_data: { editor },
			onclick: [autoLayout],
			type: "button",
		},
		[el("span.dhx_button__text", locale.autoLayout)]
	);

	const scale = el(".dhx_editor_scale", [
		el(".dhx_zoom_in", {
			class: "dxi dxi-minus",
			onclick: [zoomAction],
			_data: { editor, dir: "out" },
		}),
		el(".dhx_scale_value", (editor.config.scale * 100).toFixed(0) + "%"),
		el(".dhx_zoom_out", {
			class: "dxi dxi-plus",
			onclick: [zoomAction],
			_data: { editor, dir: "in" },
		}),
	]);

	const iconType = editor.config.editMode ? "dxi-eye" : "dxi-eye-off dhx_selected";

	const visibility = el(".dhx_visibility", {
		class: `dxi ${iconType}`,
		onclick: [visibilityAction],
		_data: { editor, visible: true },
	});

	const left = el(".dhx_items_block", [
		controls.export && buttonExport,
		controls.import && buttonImport,
		controls.autoLayout && buttonAutoLayout,
		controls.editManager && visibility,
		controls.scale && scale,
	]);

	const undo = el(".dhx_state_block", [
		el("div", {
			dhx_id: "undo",
			_data: { editor },
			onclick: [undoAction],
			class: "undo dxi dxi-undo " + (state?.isUndo() ? "undo--active" : ""),
		}),
		el("div", {
			dhx_id: "redo",
			_data: { editor },
			onclick: [redoAction],
			class: "redo dxi dxi-redo " + (state?.isRedo() ? "redo--active" : ""),
		}),
	]);

	return el(
		"div",
		{
			class: "dhx_topbar_wrap",
			style: { display: "flex", justifyContent: "space-between", width: "100%", height: "100%" },
		},
		[controls.reset && buttonReset, controls.apply && buttonApply, controls.historyManager && undo, left]
	);
}
